import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from '../../environments/environment';

@Injectable({
    providedIn: 'root'
})

export class ProductionActivityService {

    constructor(protected http: HttpClient) {
    }

    baseurl = environment.apiBaseUrl;

    getProductionActivities() {
        return this.http.get<any[]>(this.baseurl + 'activityprocessfeedstock/productionactivities');
    }

    addProductionActivities(productionactivity: any) {
        return this.http.post<any[]>(this.baseurl + 'activityprocessfeedstock/addProductionActivity', productionactivity);
    }

    updateProductionActivities(productionactivity: any) {
        return this.http.post<any[]>(this.baseurl + 'activityprocessfeedstock/updateProductionActivity', productionactivity);
    }
}